module.exports = __webpack_public_path__ + "static/media/genesis_logo.6929a2b0.png";